<template>
  <div :class="['box', { 'box-lg': hasLgProps }, { 'overflow-hidden': overflowHidden }]" :title="title">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { setCssValueUnity } from '../helpers/ui'
import type { SpaceStyles } from '../types/ui'

const props = defineProps<SpaceStyles & { title?: string }>()

const width = computed(() => setCssValueUnity(props.w))
const height = computed(() => setCssValueUnity(props.h))
const maxWidth = computed(() => setCssValueUnity(props.maxW))
const minWidth = computed(() => setCssValueUnity(props.minW))
const maxHeight = computed(() => setCssValueUnity(props.maxH))
const minHeight = computed(() => setCssValueUnity(props.minH))
const marginValue = computed(() => {
  const { mt, mr, mb, ml, m } = props
  return (
    setCssValueUnity(m) ||
    ((mt || mr || mb || ml) &&
      `${setCssValueUnity(mt) || 0} ${setCssValueUnity(mr) || 0} ${setCssValueUnity(mb) || 0} ${setCssValueUnity(ml) || 0}`) ||
    undefined
  )
})
const paddingValue = computed(() => {
  const { pt, pr, pb, pl, p } = props
  return (
    setCssValueUnity(p) ||
    ((pt || pr || pb || pl) &&
      `${setCssValueUnity(pt) || 0} ${setCssValueUnity(pr) || 0} ${setCssValueUnity(pb) || 0} ${setCssValueUnity(pl) || 0}`) ||
    undefined
  )
})

const hasLgProps = computed(
  () => Object.entries(props).filter(([key, value]: [string, unknown]) => key.includes('lg') && !!value).length > 0,
)
const widthLg = computed(() => setCssValueUnity(props.wLg || props.w))
const heightLg = computed(() => setCssValueUnity(props.hLg || props.h))
const marginValueLg = computed(() => {
  const { mlLg, mrLg, mtLg, mbLg, mt, mb, mr, ml } = props
  return (
    ((mlLg || mrLg || mtLg || mbLg) &&
      `${setCssValueUnity(mtLg || mt) || 0} ${setCssValueUnity(mrLg || mr) || 0} ${setCssValueUnity(mbLg || mb) || 0} ${
        setCssValueUnity(mlLg || ml) || 0
      }`) ||
    undefined
  )
})
const paddingValueLg = computed(() => {
  const { plLg, prLg, ptLg, pbLg, pt, pb, pr, pl } = props
  return (
    ((plLg || prLg || ptLg || pbLg) &&
      `${setCssValueUnity(ptLg || pt) || 0} ${setCssValueUnity(prLg || pr) || 0} ${setCssValueUnity(pbLg || pb) || 0} ${
        setCssValueUnity(plLg || pl) || 0
      }`) ||
    undefined
  )
})
</script>

<style scoped>
.box {
  width: v-bind(width);
  height: v-bind(height);
  max-width: v-bind(maxWidth);
  min-width: v-bind(minWidth);
  max-height: v-bind(maxHeight);
  min-height: v-bind(minHeight);
  margin: v-bind(marginValue);
  padding: v-bind(paddingValue);
}

.overflow-hidden {
  overflow: hidden;
}

@media (min-width: 992px) {
  .box-lg {
    width: v-bind(widthLg);
    height: v-bind(heightLg);
    padding: v-bind(paddingValueLg);
    margin: v-bind(marginValueLg);
  }
}
</style>
